import api from '../services/api';
import services from '../services/services';
import { writingsOfJusticeEnum } from '@/helpers/enum';
import { attachmentType } from '@/helpers/enum.js';
import local from '@/local/ar';

export default {
  getMOIFamilyRelation: (_context, payload) => api.getMOIFamilyRelation(payload),
  checkPersonalAddress: (context, socialId) => services.checkPersonalAddress(socialId),
  checkMOIPersonalInfo: ({ rootGetters }, payload) => {
    const currentUserSocialId = +rootGetters['GlobalModule/socialId'];
    return services[payload.firstName ? 'checkMOIPersonalInfoByFirstName' : 'checkMOIPersonalInfo']({ ...payload }).then((personObj) => {
      if ((+payload.socialId === currentUserSocialId) || !!payload.allowAddressCheck) {
        return services
          .checkPersonalAddress(payload.socialId, payload.isDefendant)
          .then(address => ({
            ...personObj,
            ...address,
          }))
          .catch(() => personObj);
      } else return personObj;
    });
  },
  checkCommercialRegistrationNumber: (context, payload) => services.checkCommercialRegistrationNumber(payload),
  checkCaptchaRequiredResponse: () => services.checkCaptchaRequiredResponse(),
  validateAgentAttorney: (context, payload) => services.validateAgentAttorney(payload),
  validateAgentAttorneyIncludeExternal: (context, payload) => services.validateAgentAttorneyIncludeExternal(payload),
  validateLawyerAttorney: (context, payload) => {
    return api
      .validateLawyer(payload.lawyerSocialId, payload.isTraineeLawyer)
      .then(() => {
        let attorneyObject;
        if (payload.isTraineeLawyer) {
          return api
            .validateLawyer(payload.mainLawyerSocialId, false) // المحامي الاساسي
            .then(() => {
              attorneyObject = {
                attorneyCode: payload.mainAttorneyNumber,
                agentSocialId: payload.mainLawyerSocialId,
                clientSocialId: payload.clientSocialId,
                attorneyType: payload.attorneyType,
                excludeCurrentUser: true,
              };
              return services
                .validateAgentAttorney(attorneyObject)
                .then(() => {
                  attorneyObject = {
                    attorneyCode: payload.attorneyNumber,
                    agentSocialId: payload.lawyerSocialId,
                    clientSocialId: payload.mainLawyerSocialId,
                    attorneyType: writingsOfJusticeEnum.internalAttorney,
                  };
                  return services.validateAgentAttorney(attorneyObject);
                });
            });
        } else {
          attorneyObject = {
            attorneyCode: payload.attorneyNumber,
            agentSocialId: payload.lawyerSocialId,
            clientSocialId: payload.clientSocialId,
            attorneyType: payload.attorneyType,
          };
          return api.validateAttorneyExistence(attorneyObject);
        }
      });
  },
  validateLawyer: (context, payload) => api.validateLawyer(payload.socialId, payload.isTraineeLawyer,
    payload.overrideErrorHandlingBehaviour),
  validateRegency: (context, payload) => api.validateRegency(payload),
  validateGuardianship: (context, payload) => api.validateGuardianship(payload),
  getPrisonerCriminalRecord: (context, payload) =>
    services.getPrisonerCriminalRecord(payload), // payload = { socialId, dateOfBirth }
  validateReconciliationCode: async (_context, payload) => {
    const {
      reconciliationRequestCode,
      socialId,
      unifiedNumber,
      commercialRegistrationNumber,
    } = payload;

    const idsToTry = [
      socialId,
      unifiedNumber,
      commercialRegistrationNumber,
    ].filter(id => !!id);

    let lastError = null;

    for (const id of idsToTry) {
      try {
        const apiPayload = {
          reconciliationRequestCode,
          socialId: id,
        };
        const response = await api.validateReconciliationCode(apiPayload);
        return response;
      } catch (error) {
        lastError = error;
      }
    }
    if (lastError)
      throw lastError;
  },
  validateInheritor: (_context, payload) => api.validateInheritor(payload),
  verifyLeaseContract(context, payload) {
    return new Promise((resolve, reject) => {
      api[typeof (payload) === 'object' ?
        'getContractCopy' : 'getCheckContractStatus'](payload)
        .then((res) => {
          if (res && res.status == 200) {
            const name = (res.data || {}).fileName ? res.data.fileName : local.dynamicFormAdmin.customComponents.ContractDetails.categoryName;
            const fileUrl = (res.data || {}).contractFile;
            const category = 1873;
            const extension = (res.data || {}).fileExtension ? res.data.fileExtension : '.pdf';
            const fileType = extension === '.pdf' ? attachmentType.pdf : attachmentType.image;
            const firstParty = (res.data || {}).firstParty || {};
            const secondParty = (res.data || {}).secondParty || {};
            const fullAddress = (res.data || {}).fullAddress || {};
            let attachment = {
              fileName: name,
              fileType,
              content: fileUrl,
              fileCategory: category,
              extension,
              isAttachmentAudited: true,
            };
            context.dispatch('GlobalModule/handleAttachments', {
              attachments: [attachment],
              fileCategory: attachment.fileCategory,
              resolve,
            }, { root: true }).then((succeeded) => {
              resolve({
                succeeded,
                firstParty,
                secondParty,
                fullAddress,
              });
            });
          }
          else
            reject(local.common.noData);
        })
        .catch(() => {
          reject(local.common.noData);
        });
    });
  },
};
